import { Component, Input } from '@angular/core';
import { AlertTicket, TicketStatusId } from '@shared/services';


@Component({
  selector: 'app-alert-ticket-status',
  templateUrl: './alert-ticket-status.component.html',
  styleUrls: ['./alert-ticket-status.component.scss'],
  standalone: false
})
export class AlertTicketStatusComponent {

  @Input() ticket: AlertTicket;
  @Input() fontSize: string;

  @Input() alwaysDisplayFaultStatus = false;
  @Input() hidePriority = false;
  @Input() singlePill = false;

  TicketStatusId = TicketStatusId;

}
